import React from "react";

const CardDsfrContext = React.createContext({
  isHorizontal: false,
  hasGreyBackground: false,
  highlighted: false,
  showImage: false,
  showBadge: false,
  showDetail: false,
  showDescription: false,
});
export default CardDsfrContext;
